/* eslint-disable import/no-cycle */
import { setupAPIClient } from './api';

export const api = setupAPIClient();
